import { render, staticRenderFns } from "./GuideLanding.vue?vue&type=template&id=1c4984ab&scoped=true"
import script from "./GuideLanding.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuideLanding.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./GuideLanding.vue?vue&type=style&index=0&id=1c4984ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4984ab",
  null
  
)

export default component.exports